export const BANKS_IDS = {
  OTKRITIE: '942',
};
